<template>
  <div
    class="wf-relative"
    :class="! $root.previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! $root.previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div
      :class="elementClasses(classes('containerClasses'))"
    >
      <div
        :class="elementClasses(classes('classes'), [...classes('customClasses'), 'wf-inline-block'])"
        :style="elementStyles(styles('styles'))"
      >
        <div v-if="content.srcType == 'videojs'">
          <video-player
            :source="srcLink"
            :autoplay="content.autoplay"
            :theme-color="colorStyle"
            :width="videoWidth" :height="videoHeight"
          />
        </div>
        <div v-else>
          <embed-player
            :source="srcLink"
            :source-type="content.srcType"
            :autoplay="content.autoplay"
            ratio="16:9"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {StylesParser} from "../StylesParser"
import VideoPlayer from "./VideoPlayer"
import EmbedPlayer from "./EmbedPlayer"
import EditorComponent from "../contracts/EditorComponent"
export default EditorComponent.extend({
  components: {
    EmbedPlayer, VideoPlayer
  },

  computed: {
    containerId() {
      return this.$store.getters[`${this.module}/id`](this.element, 'container_id')
    },
    videoWidth() {
      let WidthStyle = {desktop: [], tablet: [], phone: []}
      let width = this.styles[this.device].find(style => style.property === 'WidthStyle')
      if (width) {
        this.$set(WidthStyle, this.device, [width])
      }
      return (new StylesParser(WidthStyle, this.device)).parse()
    },
    videoHeight() {
      let heightStyle = {desktop: [], tablet: [], phone: []}
      let height = this.styles[this.device].find(style => style.property === 'HeightStyle')
      if (height) {
        this.$set(heightStyle, this.device, [height])
      }
      return (new StylesParser(heightStyle, this.device)).parse()
    },
    colorStyle() {
      let colorStyles = { desktop: [], tablet: [], phone: []}
      let color = this.styles[this.device].find(style => style.property === 'TextColor')
      if (color) {
        this.$set(colorStyles, this.device, [color])
      }
      return (new StylesParser(colorStyles, this.device)).parse()
    },
    srcLink() {
      let srcLink = this.$store.getters[`${this.module}/content`](this.element).srcLink
      return srcLink ? srcLink: ''
    },
    // videoOptions() {
      //youtube => https://www.youtube.com/embed/m7npyvrUpGw
      //youtube => https://www.youtube.com/watch?v=iXPm46lZeyg
      //local => /video/SmallVideo.mp4
      //external => http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4
      //webm => http://techslides.com/demos/sample-videos/small.webm
      //vimeo => https://player.vimeo.com/external/242179560.hd.mp4?s=b8881ea811a3401c55d8305d11db0ec93ecaa263&profile_id=175
    // },
  },
})
</script>
